import { faGear } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { useLoggedCallback } from '@sorare/core/src/hooks/useLoggedCallback';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';
import {
  PlayerSearchViewAttributes,
  StatsOnboarding,
} from '@sorare/core/src/lib/playerSearchView';

import { PlayerSearchHelp } from 'searchCommonPlayer/PlayerSearchHelp';
import { useManagePlayerSearchView } from 'searchCommonPlayer/StatsManager/useManagePlayerSearchView';

import { StatsManager } from '../StatsManager';

const Root = styled(Vertical)`
  flex-shrink: 0;
`;
export const ToggleStatsManager = () => {
  const [open, setOpen] = useState(false);
  const { up: tabletOrAbove } = useScreenSize('tablet');
  const { statsManager, sawOnboarding } = useManagePlayerSearchView();

  const onClick = useLoggedCallback(() => {
    setOpen(true);
    if (
      statsManager[PlayerSearchViewAttributes.ONBOARDING] ===
      StatsOnboarding.INIT
    ) {
      sawOnboarding(StatsOnboarding.INIT);
    }
  });
  const onClose = () => {
    if (
      statsManager[PlayerSearchViewAttributes.ONBOARDING] ===
      StatsOnboarding.ADVANCED_VIEW
    ) {
      sawOnboarding(StatsOnboarding.ADVANCED_VIEW);
    }
    setOpen(false);
  };

  return (
    <Root center>
      <PlayerSearchHelp
        placement={tabletOrAbove ? 'left' : 'top'}
        step={StatsOnboarding.INIT}
      >
        <Button
          size="small"
          startIcon={<FontAwesomeIcon icon={faGear} />}
          onClick={onClick}
          color="quaternary"
          blur
        >
          <FormattedMessage {...scoutingCenter.advancedView} />
        </Button>
      </PlayerSearchHelp>
      <StatsManager open={open} onClose={onClose} />
    </Root>
  );
};
